
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const initiateConfirmTransferApi = createAsyncThunk("initiateConfirmTransfer", async () => {
  const response = await axiosInstance.get("/initiateConfirmTransfer");
  return response.data;
});

const initiateConfirmTransferSlice = createSlice({
  name: "initiateConfirmTransfer",
  initialState: {
    initiateConfirmTransfer: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initiateConfirmTransferApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(initiateConfirmTransferApi.fulfilled, (state, action) => {
        state.initiateConfirmTransfer = action.payload;
        state.loading = false;
      })
      .addCase(initiateConfirmTransferApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default initiateConfirmTransferSlice.reducer;
